import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cva } from 'class-variance-authority';
import cn from 'classnames';

import { mapSpecContract } from '@/common/config/contract';
import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import {
  selectSpecContractIsFail,
  selectSpecContractOpenDateByKind,
} from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import { getTexts } from './config';

import css from './styles.module.scss';

const contractDescriptionVariant = cva('', {
  variants: {
    variant: {
      normal: css.normalContractDescr,
      small: css.smallContractDescr,
    },
  },
});

interface ContractDescriptionProps {
  kind: SpecContractType | PaidSpecContractType;
}

const ContractDescription: FC<ContractDescriptionProps> = ({ kind }) => {
  const openDate = useAppSelector((state) =>
    selectSpecContractOpenDateByKind(state, kind),
  );
  const contractIsFail = useAppSelector((state) =>
    selectSpecContractIsFail(state, kind),
  );
  const { t } = useTranslation();
  const { inProgres, forOpening } = getTexts(t)[mapSpecContract[kind]];

  return (
    <p
      className={cn(
        contractDescriptionVariant({
          variant: openDate ? 'small' : 'normal',
        }),
        contractIsFail && 'opacity-50',
        kind === 'Blitz' && '!max-w-[20rem] !mb-0',
      )}
    >
      {openDate ? inProgres : forOpening}
    </p>
  );
};

export { ContractDescription };
